// this reducer contains all the basic app info
// the most important being the playtest state

import {Platform} from 'react-native';
import {createSlice} from '@reduxjs/toolkit';
import {mmkvStorage} from '../../Utils/mmkvStorage';

const initialState = {
  deviceUUID: mmkvStorage.getString('deviceUUID'),
  customAdView: false, // this is used by some facebook ads
  utm_source: false,
  utm_medium: false,
  utm_campaign: false,
  utm_term: false,
  playTestState: Platform.OS == 'ios' ? true : false, // this is used for testing and app store submissions
  passportPrice: 24.99,
  passportRechargePrice: 19.99,
  showOnlyExplorerPass: false,

  expoUpdateAvailable: 0,
  useLocalHost: 0,
};

const appInfoSlice = createSlice({
  name: 'app_info',
  initialState,
  reducers: {
    setDeviceUUID(state, deviceUUID) {
      state.deviceUUID = deviceUUID;
    },
    // this is the function that sets playtest state from the firebase state
    // this is stored here: https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/versionInfo
    setVersionInfo(state, {payload}) {
      console.log('setVersionInfo', payload);
      return {
        ...state,
        playTestState: payload.playTestState,
        smallGroupVideoId: payload.smallGroupVideoId,
        largeGroupVideoId: payload.largeGroupVideoId,
        passportPrice: payload.passportPrice,
        passportRechargePrice: payload.passportRechargePrice,
        passportShown: payload.passportShown,
        showOnlyExplorerPass: payload.showOnlyExplorerPass || false,
        status: payload.status || false,
      };
    },
    setCustomAdView(state, {payload: customAdView}) {
      state.customAdView = customAdView;
    },
    setUTMSource(state, {payload: utm_source}) {
      state.utm_source = utm_source;
    },
    setUTMMedium(state, {payload: utm_medium}) {
      state.utm_medium = utm_medium;
    },
    setUTMCampaign(state, {payload: utm_campaign}) {
      state.utm_campaign = utm_campaign;
    },
    setUTMTerm(state, {payload: utm_term}) {
      state.utm_term = utm_term;
    },
    setExpoUpdateAvailable(state, {payload: expoUpdateAvailable}) {
      state.expoUpdateAvailable = expoUpdateAvailable;
    },
    setUseLocalHost(state, {payload: useLocalHost}) {
      console.log('setUseLocalHost ' + useLocalHost);
      state.useLocalHost = useLocalHost;
    },
  },
});

export const {
  setDeviceUUID,
  setVersionInfo,
  setCustomAdView,
  setUTMSource,
  setUTMMedium,
  setUTMCampaign,
  setUTMTerm,

  setExpoUpdateAvailable,
  setUseLocalHost,
} = appInfoSlice.actions;

export default appInfoSlice.reducer;
